var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.type === "edit" ? "编辑" : "新增",
        visible: _vm.dialog,
        width: _vm.getIsMobile ? "100%" : "50%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialog = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          staticClass: "custom-form",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            "label-position": _vm.getIsMobile ? "top" : "right",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "型号", prop: "xhname" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入型号" },
                model: {
                  value: _vm.form.xhname,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "xhname", $$v)
                  },
                  expression: "form.xhname",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "品牌", prop: "source" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入品牌" },
                model: {
                  value: _vm.form.source,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "source", $$v)
                  },
                  expression: "form.source",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "供应商", prop: "gongyingshang" } },
            [
              _c(
                "el-select",
                {
                  ref: "selectRef",
                  staticClass: "model-select",
                  attrs: {
                    filterable: "",
                    remote: "",
                    "popper-append-to-body": "",
                    "reserve-keyword": "",
                    "automatic-dropdown": true,
                    "default-first-option": true,
                    placeholder: "请输入供应商",
                    "remote-method": _vm.remoteMethod,
                    loading: _vm.loading,
                  },
                  on: { change: _vm.handleChange },
                  model: {
                    value: _vm.form.gongyingshang,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "gongyingshang", $$v)
                    },
                    expression: "form.gongyingshang",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "库存数量", prop: "number" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入库存数量" },
                model: {
                  value: _vm.form.number,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "number", _vm._n($$v))
                  },
                  expression: "form.number",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "未税价格", prop: "wshui" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 14 } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入未税价格" },
                        on: {
                          focus: function ($event) {
                            _vm.activeShuiFiled = "wshui"
                          },
                        },
                        model: {
                          value: _vm.form.wshui,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "wshui", $$v)
                          },
                          expression: "form.wshui",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 9 } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: "请输入税率" },
                          model: {
                            value: _vm.taxRate,
                            callback: function ($$v) {
                              _vm.taxRate = $$v
                            },
                            expression: "taxRate",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { slot: "append" }, slot: "append" },
                            [_vm._v("税率")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "含税价格", prop: "hshui" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入含税价格" },
                on: {
                  focus: function ($event) {
                    _vm.activeShuiFiled = "hshui"
                  },
                },
                model: {
                  value: _vm.form.hshui,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "hshui", $$v)
                  },
                  expression: "form.hshui",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "商品名称", prop: "title" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "title", $$v)
                    },
                    expression: "form.title",
                  },
                },
                _vm._l(_vm.category, function (item) {
                  return _c(
                    "el-radio",
                    { key: item.id, attrs: { label: item.classname } },
                    [_vm._v(_vm._s(item.classname))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "进货日期", prop: "settime" } },
            [
              _c("el-date-picker", {
                staticClass: "custom-date-picker",
                attrs: {
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                  placeholder: "选择日期",
                },
                model: {
                  value: _vm.form.settime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "settime", $$v)
                  },
                  expression: "form.settime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "自定义价格", prop: "zdyprice" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入自定义价格" },
                model: {
                  value: _vm.form.zdyprice,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "zdyprice", $$v)
                  },
                  expression: "form.zdyprice",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "产地", prop: "address" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入产地" },
                model: {
                  value: _vm.form.address,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "address", $$v)
                  },
                  expression: "form.address",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "包装", prop: "baozhuang" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入包装" },
                model: {
                  value: _vm.form.baozhuang,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "baozhuang", $$v)
                  },
                  expression: "form.baozhuang",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "beizhu" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入备注" },
                model: {
                  value: _vm.form.beizhu,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "beizhu", $$v)
                  },
                  expression: "form.beizhu",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "库房货位", prop: "kufang" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入库房货位" },
                model: {
                  value: _vm.form.kufang,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "kufang", $$v)
                  },
                  expression: "form.kufang",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "收票发票号", prop: "spfph" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入收票发票号" },
                model: {
                  value: _vm.form.spfph,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "spfph", $$v)
                  },
                  expression: "form.spfph",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "收票状态", prop: "spzt" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.spzt,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "spzt", $$v)
                    },
                    expression: "form.spzt",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("未税")]),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("已到")]),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("未到")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "合同状态", prop: "zt" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.zt,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "zt", $$v)
                    },
                    expression: "form.zt",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("开放")]),
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("锁定")]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleReset } }, [
            _vm._v("重 置"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }